import React, { useEffect, useState } from 'react';
import { Loader, Modal } from '@mantine/core';
import FileViewer from '../../FileViewer';
import { useDisclosure } from '@mantine/hooks';
import {useAgLazyQuery, useAsyncEffect, isMicrosoftType, errorBoundaryWrapper} from '@repo/utils';
import { AimApi, useLazyAttachmentByPidQuery } from '@repo/services';

interface ImagePreviewModalProps {
  pid: string | undefined;
  handleClose: () => void;
}

const AttachmentPreviewModal = ({ pid, handleClose }: ImagePreviewModalProps) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedAttachment, selectedAttachmentIsLoading] = useAgLazyQuery(pid, useLazyAttachmentByPidQuery);
  const [uri, setUri] = useState<string | undefined>(undefined);
  const [filename, setFilename] = useState<string | undefined>(undefined);

  const handleClosePreview = () => {
    handleClose();
    setUri(undefined);
    setFilename(undefined);
    close();
  };

  useAsyncEffect(async () => {
    if (selectedAttachment) {
      if (isMicrosoftType(selectedAttachment?.mimetype)) {
        const uri = encodeURIComponent(selectedAttachment?.fullUrl as string);
        // const uri = encodeURIComponent(selectedAttachment?.url as string);
        setUri(uri);
      } else if (selectedAttachment?.mimetype === 'application/pdf') {
        const { data: blob } = await AimApi.aim.attachments.getFileBlob({ pid: selectedAttachment?.pid });
        const uri = URL.createObjectURL(blob);
        setUri(uri);
      } else {
        setUri(selectedAttachment?.previewUrl);
      }
      setFilename(selectedAttachment?.filename);
    } else {
      setUri(undefined);
    }
  }, [selectedAttachment]);

  useEffect(() => {
    if (pid) {
      open();
    }
  }, [pid]);

  return (
      <Modal opened={opened} onClose={handleClosePreview} title={filename} size='xl'>
        {selectedAttachment && uri && selectedAttachment?.pid === pid && (
            <FileViewer previewFileType={selectedAttachment?.mimetype} url={uri} />
        )}
        {selectedAttachmentIsLoading && (
            <div
                style={{
                  textAlign: 'center',
                  marginTop: '50%',
                  width: '100%',
                  height: window.innerHeight * 0.9
                }}
            >
              <Loader />
              <div>Fetching attachment...</div>
            </div>
        )}
      </Modal>
  );
};

export default errorBoundaryWrapper(AttachmentPreviewModal);
